import { takeLatest, put, call } from 'redux-saga/effects';
import { history } from '@commons';
import { storage } from '@commons/storage';
import { createContaCaixaCadastro, updateContaCaixaCadastro } from '../service';
import {
  CREATE_CONTA_CAIXA_CADASTRO,
  CREATE_CONTA_CAIXA_CADASTRO_PENDING,
  CREATE_CONTA_CAIXA_CADASTRO_SUCCESS,
  CREATE_CONTA_CAIXA_CADASTRO_FAILURE,
  CONFIG_SESSION
} from '@handler';
import {
  AlertSuccess,
  AlertError,
  AlertWarning,
} from '@components/common/AlertToast';
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaCreateContaCaixaCadastro(action) {
  yield put({ type: CREATE_CONTA_CAIXA_CADASTRO_PENDING });

  try {
    if (!action.data.saldoInicialImplantado) {
      action.data.saldoInicial = {
        data: '',
        valor: 0
      }
    }
    if (action.data.id === undefined || action.data.id === null) {
      yield call(createContaCaixaCadastro, {
        ...action.data,
        propriedade: {
          id: JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id
        }
      });
      trackingEventCX('action', MODULE_ACTIONS_ENUM.CADASTRO_CONTA_CAIXA_CRIAR);
    } else {
      yield call(updateContaCaixaCadastro,
        {
          ...action.data,
          id: action.data.id
        }
      );
      trackingEventCX('action', MODULE_ACTIONS_ENUM.CADASTRO_CONTA_CAIXA_EDITAR);
    }

    yield put({ type: CREATE_CONTA_CAIXA_CADASTRO_SUCCESS, registro: action.data });

    if(!action.isCadastroRapido){
      history.push('/financeiro/contaCaixaCadastro');
    }

    AlertSuccess('Registro salvo com sucesso!');
  } catch (error) {
    yield put({ type: CREATE_CONTA_CAIXA_CADASTRO_FAILURE, registro: action.data });

    if (error.response.status === 422) {
      AlertWarning(error.response.data.text);
    } else {
      AlertError('Falha ao salvar o registro! Tente novamente...');
    }
  }
}

export default function* watchCreateContaCaixaCadastro() {
  yield takeLatest(CREATE_CONTA_CAIXA_CADASTRO, sagaCreateContaCaixaCadastro);
}
